/** Unit options for product Pricing & Quantity (Alibaba-style list). */
export type ProductUnitOption = {
  value: string;
  label: string;
};

export const PRODUCT_UNIT_OPTIONS: ProductUnitOption[] = [
  { value: "acre", label: "Acre/Acres" },
  { value: "ampere", label: "Ampere/Amperes" },
  { value: "bag", label: "Bag/Bags" },
  { value: "barrel", label: "Barrel/Barrels" },
  { value: "blade", label: "Blade/Blades" },
  { value: "box", label: "Box/Boxes" },
  { value: "bushel", label: "Bushel/Bushels" },
  { value: "carat", label: "Carat/Carats" },
  { value: "carton", label: "Carton/Cartons" },
  { value: "case", label: "Case/Cases" },
  { value: "centimeter", label: "Centimeter/Centimeters" },
  { value: "chain", label: "Chain/Chains" },
  { value: "cubic-inch", label: "Cubic Inch/Cubic Inches" },
  { value: "cubic-meter", label: "Cubic Meter/Cubic Meters" },
  { value: "cubic-yard", label: "Cubic Yard/Cubic Yards" },
  { value: "degrees-celsius", label: "Degrees Celsius" },
  { value: "degrees-fahrenheit", label: "Degrees Fahrenheit" },
  { value: "dozen", label: "Dozen/Dozens" },
  { value: "dram", label: "Dram/Drams" },
  { value: "fluid-ounce", label: "Fluid Ounce/Fluid Ounces" },
  { value: "foot", label: "Foot/Feet" },
  { value: "forty-foot-container", label: "Forty-Foot Container" },
  { value: "furlong", label: "Furlong/Furlongs" },
  { value: "gallon", label: "Gallon/Gallons" },
  { value: "gill", label: "Gill/Gills" },
  { value: "inch", label: "Inch/Inches" },
  { value: "kiloampere", label: "Kiloampere/Kiloamperes" },
  { value: "kilogram", label: "Kilogram/Kilograms" },
  { value: "kilohertz", label: "Kilohertz" },
  { value: "kilometer", label: "Kilometer/Kilometers" },
  { value: "kiloohm", label: "Kiloohm/Kiloohms" },
  { value: "kilovolt", label: "Kilovolt/Kilovolts" },
  { value: "kilowatt", label: "Kilowatt/Kilowatts" },
  { value: "liter", label: "Liter/Liters" },
  { value: "long-ton", label: "Long Ton/Long Tons" },
  { value: "megahertz", label: "Megahertz" },
  { value: "meter", label: "Meter/Meters" },
  { value: "metric-ton", label: "Metric Ton/Metric Tons" },
  { value: "mile", label: "Mile/Miles" },
  { value: "milliwatt", label: "Milliwatt/Milliwatts" },
  { value: "nautical-mile", label: "Nautical Mile/Nautical Miles" },
  { value: "ohm", label: "Ohm/Ohms" },
  { value: "ounce", label: "Ounce/Ounces" },
  { value: "pack", label: "Pack/Packs" },
  { value: "pair", label: "Pair/Pairs" },
  { value: "pallet", label: "Pallet/Pallets" },
  { value: "parcel", label: "Parcel/Parcels" },
  { value: "perch", label: "Perch/Perches" },
  { value: "pieces", label: "Piece/Pieces" },
  { value: "quarter", label: "Quarter/Quarters" },
  { value: "rod", label: "Rod/Rods" },
  { value: "roll", label: "Roll/Rolls" },
  { value: "set", label: "Set/Sets" },
  { value: "sheet", label: "Sheet/Sheets" },
  { value: "short-ton", label: "Short Ton/Short Tons" },
  { value: "square-centimeter", label: "Square Centimeter/Square Centimeters" },
  { value: "square-foot", label: "Square Foot/Square Feet" },
  { value: "square-inch", label: "Square Inch/Square Inches" },
  { value: "square-meter", label: "Square Meter/Square Meters" },
  { value: "square-mile", label: "Square Mile/Square Miles" },
  { value: "square-yard", label: "Square Yard/Square Yards" },
  { value: "stone", label: "Stone/Stones" },
  { value: "strand", label: "Strand/Strands" },
  { value: "ton", label: "Ton/Tons" },
  { value: "tonne", label: "Tonne/Tonnes" },
  { value: "tray", label: "Tray/Trays" },
  { value: "twenty-foot-container", label: "Twenty-Foot Container" },
  { value: "unit", label: "Unit/Units" },
  { value: "volt", label: "Volt/Volts" },
  { value: "watt", label: "Watt/Watts" },
  { value: "yard", label: "Yard/Yards" },
];

const LEGACY_UNIT_LABELS: Record<string, string> = {
  kg: "Kilogram/Kilograms",
  tons: "Ton/Tons",
  meters: "Meter/Meters",
  pairs: "Pair/Pairs",
  sets: "Set/Sets",
  cartons: "Carton/Cartons",
};

const optionValues = new Set(PRODUCT_UNIT_OPTIONS.map((o) => o.value));

export function getProductUnitLabel(value: string | undefined | null): string {
  if (!value) return "Piece/Pieces";
  const option = PRODUCT_UNIT_OPTIONS.find((o) => o.value === value);
  if (option) return option.label;
  if (LEGACY_UNIT_LABELS[value]) return LEGACY_UNIT_LABELS[value];
  return value;
}

/** Options for Select, including legacy stored values not in the standard list. */
export function getProductUnitSelectOptions(
  currentValue?: string | null,
): ProductUnitOption[] {
  if (!currentValue || optionValues.has(currentValue)) {
    return PRODUCT_UNIT_OPTIONS;
  }
  return [
    { value: currentValue, label: getProductUnitLabel(currentValue) },
    ...PRODUCT_UNIT_OPTIONS,
  ];
}

export const DEFAULT_PRODUCT_UNIT = "pieces";
